// src/App.js
import React from "react";
import Header from "./components/Header";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import About from "./components/About";
import Contact from "./components/Contact";

const App = () => (
  <div style={styles.container}>
    <Header />
    <Services id="services" />
    <Benefits id="benefits" />
    <About id="about" />
    <Contact id="contact" />
  </div>
);
const styles = {
  container: {
    maxWidth: "90rem",
    marginLeft: "auto",
    marginRight: "auto",
  },
};
export default App;
